export default __webpack_public_path__ + "f2d2a65f4feef8df77b89f927aca8e56.png";